"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const __theme_1 = __importDefault(require("./styles/_.theme"));
const form_options_1 = require("./form.options");
exports.default = (0, mobx_1.makeAutoObservable)({
    theme: __theme_1.default,
    showOptions: false,
    open: false,
    forms: {},
    menu: {},
    select: {},
    selected: {
        key: null,
        form: null,
    },
    dock: {
        visible: true,
        fluid: false,
        size: 350,
        position: 'right',
        mode: 'none',
        style: {
            background: __theme_1.default.base00,
        },
    },
    get formOptions() {
        return (0, form_options_1.makeFormOptions)(this.selected.form);
    },
});
